import { useContext } from 'react';
import { Box } from '@mantine/core';
import EmailHistoryList from '../../Organismns/Message/EmailHistoryList';
import PaginationNav from '../../Molecules/Navigation/PaginationNav';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import EmailsListHeader from '../../Organismns/Message/EmailsListHeader';

const EmailMasterDetail = () => {
  const { pageNumber, totalCount, pageCount, setPageNumber, messages } = useContext(EmailBoxContext);
  const emptyBox = messages.length === 0;

  return (
    <Box pos="relative" sx={{ minHeight: 5 * 95 + 120, height: messages.length * 95 + 150 }}>
      <EmailsListHeader desktop />
      <EmailHistoryList />
      {!emptyBox && (
        <Box pos="absolute" sx={{ bottom: 10, width: '100%' }}>
          <PaginationNav
            pageSize={10}
            pageNumber={pageNumber}
            totalCount={totalCount}
            totalPages={pageCount}
            onChange={(newPageNumber) => setPageNumber(newPageNumber - 1)}
            entityName="Nachricht"
          />
        </Box>
      )}
    </Box>
  );
};

export default EmailMasterDetail;
